import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import get from 'lodash/get'
import moment from 'moment'

import { revenueType } from '../../../constants'
import { SearchSelect } from '../../../../../../input'
import { CustomDatePicker } from '../../../../../../datepicker'
import { FONTS } from '../../../../../../../constants'
import { projectInformationSelector } from '../../../../../../../selectors'
import { REACT_APP_IS_ACTUAL_REVENUE_ALLOCATION_EDITABLE } from '../../../../../../../lib/utils/envConstants'

export const InputFirstRow = React.memo(props => {
  const {
    id,
    data,
    isEdit,
    projectByID,
    invalidList,
    allocation_id,
    handleChangeDate,
    handleChangeSelect,
  } = props
  const ppsLatestSubmittedDate = useSelector(projectInformationSelector.getPPSLatestSubmittedDate)
  const lobAllocation = get(data, 'lobs', [])[id]
  const { start_date, end_date, criteria } = lobAllocation
  const allCriteria = revenueType[data.type].criteria
  const startDateProj = !REACT_APP_IS_ACTUAL_REVENUE_ALLOCATION_EDITABLE && ppsLatestSubmittedDate !== '' ? moment(ppsLatestSubmittedDate).add(1, 'month').startOf('month') : projectByID.start_date
  const endDateProj = projectByID ? projectByID.end_date : null
  const isDisable = !REACT_APP_IS_ACTUAL_REVENUE_ALLOCATION_EDITABLE && ppsLatestSubmittedDate !== '' && moment(ppsLatestSubmittedDate).isSameOrAfter(start_date, 'month')

  return (
    <Root>
      <FormWrapper>
        <Label>Criteria</Label>
        <SearchSelect
          menuPosition='absolute'
          options={ allCriteria }
          isDisabled={ !isEdit || isDisable }
          invalid={ isEdit && invalidList[`${allocation_id}_${id}_criteria`] }
          value={ allCriteria.find(c => c.value === criteria) || null }
          onChange={ e => handleChangeSelect(e, allocation_id, id, 'criteria') }
        />
      </FormWrapper>
      <FormWrapper>
        <Label>Start Date</Label>
        <CustomDatePicker
          popperPlacement='bottom'
          disabled={ !isEdit || isDisable }
          minDate={ moment(startDateProj) }
          maxDate={ moment(endDateProj) }
          selected={ start_date ? moment(start_date) : null }
          dateFormat='DD/MM/YYYY'
          onChange={ e => handleChangeDate(e, allocation_id, id, 'start_date') }
        />
      </FormWrapper>
      <FormWrapper>
        <Label>End Date</Label>
        <CustomDatePicker
          popperPlacement='bottom'
          disabled={ !isEdit }
          minDate={ moment(startDateProj) }
          maxDate={ moment(endDateProj) }
          selected={ end_date ? moment(end_date) : null }
          dateFormat='DD/MM/YYYY'
          onChange={ e => handleChangeDate(e, allocation_id, id, 'end_date') }
        />
      </FormWrapper>
    </Root>
  )
})

const Root = styled.div`
    height: 60px;
    display: flex;
    margin-bottom: 10px;
    padding-top: 12px;
`

const FormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;

    :nth-child(1) {
        padding-right: 6px;
    }

    :nth-last-child(1) {
        padding-left: 6px;
    }
`

const Label = styled.span`
    font-family: ${FONTS.GOTHAM};
    font-size: 10px;
    color: #808080;

    ${p => p.required && `
      ::after {
        content: '*';
        color: red;
      }
    `}
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-revenue-planning/revenue-table/item/project-detail/input-first-row.js